import { __assign, __rest } from "tslib";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
var BiInput = function (_a) {
    var biData = _a.biData, innerRef = _a.innerRef, props = __rest(_a, ["biData", "innerRef"]);
    var setTrackingRef = useBiClickLogger(biData).setTrackingRef;
    return (React.createElement("input", __assign({}, props, { ref: function (node) {
            setTrackingRef(node);
            innerRef && innerRef(node);
        } })));
};
BiInput.displayName = 'BiInput';
export default BiInput;
//# sourceMappingURL=BiInput.js.map